import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { Text } from '@wix/design-system';
import React from 'react';
export const AlternativesMessage = _ref => {
  let domainName = _ref.domainName,
    dataHook = _ref.dataHook;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    Trans = _DomainSearchSuiteMod.Trans;
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainNameError, null, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.storefront_results.error.domain_taken",
    values: {
      domainName
    },
    components: [/*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "bold"
    })]
  })));
};
//# sourceMappingURL=AlternativesMessage.js.map